import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../config/api";

/**
 * Stripe redirects here after successful Checkout.
 * Refreshes JWT / user so workspace plan from webhook is reflected.
 */
const BillingSuccessPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const [status, setStatus] = useState<"loading" | "ok" | "err">("loading");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setStatus("ok");
      return;
    }
    api
      .get("/auth/me")
      .then((res) => {
        const { token: fresh, workspaces: _ws, ...userData } = res.data as {
          token?: string;
          workspaces?: unknown;
          [k: string]: unknown;
        };
        if (fresh) localStorage.setItem("token", fresh);
        localStorage.setItem("user", JSON.stringify(userData));
        setStatus("ok");
      })
      .catch(() => setStatus("err"));
  }, []);

  return (
    <div className="min-h-screen bg-[#F9FAFB] flex flex-col items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg border border-[#E5E7EB] p-8 text-center">
        <div className="h-14 w-14 rounded-full bg-[#D1FAE5] flex items-center justify-center mx-auto mb-4 text-2xl">
          ✓
        </div>
        <h1 className="text-xl font-bold text-[#111827] mb-2">
          Payment received
        </h1>
        <p className="text-sm text-[#6B7280] mb-2">
          Thanks for subscribing. Your workspace plan updates automatically
          (usually within a few seconds).
        </p>
        {sessionId && (
          <p className="text-[10px] text-[#9CA3AF] mb-6 font-mono break-all">
            Session: {sessionId}
          </p>
        )}
        {status === "loading" && (
          <p className="text-xs text-[#6B7280] mb-6">Syncing your account…</p>
        )}
        {status === "err" && (
          <p className="text-xs text-amber-700 mb-6">
            Could not refresh your session. If features stay locked, sign out
            and sign in again.
          </p>
        )}
        <button
          type="button"
          onClick={() => {
            window.location.assign("/dashboard");
          }}
          className="w-full py-3 rounded-xl bg-[#2563EB] text-white text-sm font-semibold hover:bg-[#1D4ED8]"
        >
          Go to dashboard
        </button>
      </div>
    </div>
  );
};

export default BillingSuccessPage;
